import apiService from '@/core/api/apiService';
import { adaptSaveRelationPayloadForApi } from '@/core/api/adapters/relationAdapter';

const relationApiService = {
  async saveRelation(payload) {
    return apiService.createOrUpdateRelation(adaptSaveRelationPayloadForApi(payload));
  },

  async fetchRelation(hashId, options = {}) {
    return apiService.fetchRelation(hashId, options);
  },

  async listHistory({ params = {}, headers = {} } = {}) {
    return apiService.getUserImages({ params, headers });
  },

  async deleteHistoryGroup({ originalHashId, relationId }) {
    return apiService.deleteImage(originalHashId, relationId);
  },

  async touchRelation(hashId, options = {}) {
    return apiService.touchRelation(hashId, options);
  },

  async restoreRelation(hashId, relationId) {
    return apiService.restoreRelation(hashId, relationId);
  },

  async createOrUpdateRelation(payload) {
    return apiService.createOrUpdateRelation(payload);
  },

  async deleteImage(hashId, userImageRelationId) {
    return apiService.deleteImage(hashId, userImageRelationId);
  },

  async getUserImages({ params = {}, headers = {} } = {}) {
    return apiService.getUserImages({ params, headers });
  }
};

export default relationApiService;
